import Vue from 'vue';
import { update_token } from '@/services/keycloak-service';
import { MiddlewarePayload } from '@/types';
import load_profile from '../loaders/profile';
import load_time from '../loaders/time';

export default async function auth(payload: MiddlewarePayload) {
  const { next_middleware } = payload;

  await update_token();

  if (Vue.keycloak_instance.authenticated) {
    await load_profile();
    await load_time();
    return next_middleware();
  }
  return false;
}
